BaseCollection        = require('base/collection')
DispositionTeamModel = require('./model')

class DispositionTeamCollection extends BaseCollection
  model: DispositionTeamModel
  url: =>
    'callDispositions/team'

  toJSON: =>
    body = []
    for model in @models
      body.push(JSON.stringify(model))
    JSON.stringify(body)

module.exports = DispositionTeamCollection
